import { Control, UseFormSetValue } from "react-hook-form";
import { ParkingRateFormValues } from "../../parking-payment.const";
import { RateTypeEnum } from "../../pricing-configurator.types";
import { LongDurationConfigurator } from "./long-duration-configurator";
import { ShortDurationConfigurator } from "./short-duration-configurator";

type PricingConfiguratorProps = {
  control: Control<ParkingRateFormValues>;
  setValue: UseFormSetValue<ParkingRateFormValues>;
  rateType: RateTypeEnum;
};

export const PricingConfigurator = ({ control, setValue, rateType }: PricingConfiguratorProps) => {
  if (rateType === RateTypeEnum.LONG) {
    return <LongDurationConfigurator control={control} setValue={setValue} />;
  }
  return <ShortDurationConfigurator control={control} setValue={setValue} />;
};
